var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"modal-header\">\n<h3 class=\"modal-title\" translate>Kirjaudu ulos</h3>\n</div>\n<div class=\"modal-body\">\n<div class=\"form-group\">\n<p translate>\nHaluatko varmasti kirjautua ulos?\n</p>\n</div>\n<div class=\"form-group\">\n<normal-button highlight=\"true\" ng-click=\"$ctrl.submit()\">\n<span translate>Kirjaudu ulos</span>\n</normal-button>\n<normal-button ng-click=\"$ctrl.close()\">\n<span translate>Peruuta</span>\n</normal-button>\n</div>\n</div>\n</div>\n";
var id1="app/auth/modals/logout.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/modals/logout.tpl.html
// module id = 369
// module chunks = 6